import { render, staticRenderFns } from "./PortfolioIcon.vue?vue&type=template&id=2bb6e879"
import script from "./PortfolioIcon.vue?vue&type=script&lang=js"
export * from "./PortfolioIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports